import { render } from "./IconBaseButton.vue?vue&type=template&id=6fa8ff96"
import script from "./IconBaseButton.vue?vue&type=script&lang=js"
export * from "./IconBaseButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__